module.exports = __webpack_public_path__ + "media/icons/money@3x-5728a7a6.svg";